<template>
  <div class="lg-museum sticky-container" sticky-container>
    <div class="overlay-body"></div>
    <CustomYouTube />
    <Logo/>
    <Menu />
    <MenuOpen />
    <Hero :content="content"/>
    <WatchAndSee :content="content.watch" />
    <Details :content="content.details"/>
    <Announcements :content="content.announcements"/>
    <Slider :content="content.slider" />
<!--    <Footer/>-->
  </div>
</template>

<script>

import * as content from "../content/content.json";
import Hero from "../components/hero/Hero";
import Logo from "../components/logo/Logo";
import WatchAndSee from "../components/watch/WatchAndSee";
import Details from "../components/details/Details";
import Announcements from "../components/announcements/Announcements";
import Slider from "../components/slider/Slider";
import CustomYouTube from "../components/elements/youtube/CustomYouTube";
import Menu from "../components/menu/Menu";
import MenuOpen from "../components/menu/MenuOpen";

export default {
  name: "Main",
  components: {
    MenuOpen,
    Menu,
    CustomYouTube,
    Slider,
    Announcements,
    Details,
    WatchAndSee,
    Logo,
    Hero
  },
  data() {
    return {
      content: content.default
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="scss">
</style>
